import React from 'react'
import ControllerNavbar from '../../WebAppComponents/ControllerNavbar'
import "../../Styles/DeviceTable.css"
import "../../Styles/UserCard.css"
import Header from "../../WebAppComponents/Header";
import axios from "axios";
import { useNavigate } from 'react-router-dom';
import { getUserDetails, setCompNum } from "../../Utility/AsyncStorageData";
import Report from '../../Utility/Report'
import Modal from "../../WebAppComponents/Modal";
import DataTable from './DataTable';



function ControllerComp() {

    const companyColumns = [
        { label: "Id", key: "comp_num", headerStyle: { borderRadius: "10px 0 0 10px" } },
        { label: "Name", key: "name" },
        { label: "Email", key: "email"},
        { label: "WhatsApp Number", key: "ws_number" },
        { label: "Location", key: "location" },
        { label: "Device", key: "device_count" },
        {
            label: "Report",
            key: "report",
            isAction: true,
            render: () => <i className="fa fa-file-excel-o" />,
            cellStyle: { borderRadius: "0 10px 10px 0" },
            headerStyle: { borderRadius: "0 10px 10px 0" }
        }
    ];


    var userDetails = getUserDetails();
    let navigate = useNavigate();

    const [error, setError] = React.useState('');
    const [test, setTest] = React.useState(1);
    const [compDetail, setCompDetail] = React.useState({})
    const [load, setLoad] = React.useState(true);
    const [openExcel, setOpenExcel] = React.useState(false);
    const [reportDeviceId, setReportDeviceId] = React.useState("");
    const [reportname, setReportname] = React.useState("");

    const errortimer = () => {
        setError(undefined)
    }

    const navbarRender = (data) => {
        // console.log('Data received from child:', data);
        setTest(!test)
    };

    const getCompanyStatus = async () => {
        try {
            // console.log("*********** getCompanyStatus ***********")


            let url = process.env.REACT_APP_BASE_URL + "/company/fetchCompanyList";
            let body = {}
            console.log("===============getCompanyStatus======================")

            await axios.post(url, body, {
                headers: {
                    'authorization': `${userDetails.access_token}`
                },
            }).then(response => {

                if (response.status === 200) {

                    if (response.data.statusCode === 0) {

                        setCompDetail(response.data.data)
                        setLoad(false)
                    }

                    else {

                        setError(response.data.msg)
                        setTimeout(() => errortimer(), 2000)
                        console.log("error in getCompanyWiseSensorList: ", response.data.msg);
                        setLoad(false)
                    }
                }

                else if (response.status == 403) {
                    navigate("/webLogin");
                }
            }).catch(error => {
                if (error.response.status == 403) {
                    navigate("/");
                }
                setLoad(false)
                setError("ERROR")
                setTimeout(() => errortimer(), 2000)
            })
        } catch (error) {
            setLoad(false)
            navigate("/webLogin");
            console.log("error ", error)
            throw error;
        }

    }

    const navigateToDevice = (companyID) => {
        setCompNum(JSON.stringify(companyID))
        navigate("/controllerDevice")
    }

    const openExcelFlie = (item) => {
        console.log("comp_num", item)
        setOpenExcel(true)
        setReportname(item.name)
        setReportDeviceId(item.comp_num)
    }

    const receiveDataFromChild = (data) => {
        // Do something with the data received from the child component
        // console.log('Data received from child:', data);
        setOpenExcel(false);
    };


    React.useEffect(() => {
        getCompanyStatus()
    }, []);

    return (
        <div>


            <div className='main'>

                <div>
                    <ControllerNavbar />
                </div>

                <div className='Admin_menu' style={{ marginTop: "20px" }} >
                    <div>
                        <Header show={3} sendNavbarToParent={navbarRender} />
                    </div>
                    {load != 0 ?
                        <div className='load'> <img src="https://tmmapi.9930i.com/sm_loader" alt="Computer man" style={{ height: "150px" }} />
                        </div>
                        :
                        <DataTable
                            columns={companyColumns}
                            data={compDetail}
                            onRowClick={(item) => navigateToDevice(item.comp_num)}
                            onActionClick={(item) => openExcelFlie(item)}
                        />
                    }

                </div>
            </div >

            <Modal isOpen={openExcel}>
                <div>
                    <div className='report_download'>
                        <h3>Report Download</h3>
                        <i className="fa-solid fa-xmark" onClick={() => setOpenExcel(false)}></i>
                    </div>
                    <Report show={8} deviceData={reportDeviceId} reportName={reportname} sendDataToParent={receiveDataFromChild} />
                </div>
            </Modal>


        </div>
    )
}

export default ControllerComp
